<div
  *ngIf="
    !(flowKey === 'review' && !showDigitalLegalCollaboration)
  "
  class="card"
  [class]="isPagare?'pagare': ''"
>
  <div class="color-column" [ngStyle]="{ 'background-color': color }"></div>
  <div
    class="content-column"
    [class.active]="active"
    
  >
    <div class="name">
      {{ flowName }}
    </div>
    <div class="counter">{{ flowCount }}</div>
  </div>
</div>
